import CouponsPanel from "./panels/CouponsPanel";
import LikeSharePanel from "./panels/LikeSharePanel";

const tabRoutes = [
  {
    name: "Coupons",
    path: "/coupons",
    component: <CouponsPanel />
  },
  {
    name: "All Like Share",
    path: "/likeshare",
    component: <LikeSharePanel />
  }
  // {
  //   name: "Deals",
  //   path: "/deals",
  //   component: <DealsPanel />,
  // },
  // {
  //   name: "Offers",
  //   path: "/offers",
  //   component: <OffersPanel />,
  // },
];

export default tabRoutes;
